module.exports = __webpack_public_path__ + "img/img_21.cfd31820.jpg";